/* eslint-disable no-console */
import { Component, Ref, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class GalleryShowMore extends ThemeComponent {
    @Prop target!: string;

    @Ref() button!: HTMLButtonElement;

    init() {
        const hiddenGalleryItems = document.querySelectorAll(`.${this.target}`);

        if (hiddenGalleryItems.length === 0) {
            this.hideButton();
            return;
        }

        // Init click event listeners
        this.initClickEventListener(hiddenGalleryItems);
    }

    initClickEventListener(hiddenGalleryItems: NodeListOf<Element> ) {
        this.$listen(this.button, 'click', () => {
            if (!hiddenGalleryItems || hiddenGalleryItems.length === 0) {
                return;
            }

            for (const item of hiddenGalleryItems) {
                item.classList.remove(this.target);
            }

            this.hideButton();
        });
    }

    hideButton() {
        this.button.style.display = "none";
    }
}
